export interface SetComplianceFormValues {
  ringRange: RingRange;
  ringNumberRange: [number, number];
}

export enum RingRange {
  AllBoard = 'allBoard',
  Interval = 'interval',
}
